import classNames from "classnames";
import snakeCase from "lodash/snakeCase";
import { useCurrentActivity } from "PFApp/activities/show/hooks/use_current_activity";
import { useTemplate } from "PFApp/hooks";
import { Stack } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import { Variant } from "PFComponents/typography/typography.types";
import { propertyToTitle } from "PFCore/helpers/templates";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import { humanize } from "underscore.string";

import css from "./history_change_section.module.scss";

const LabelLevelVariants: Variant[] = ["h5", "bodyBold", "bodyRegular"];

type HistoryChangeSectionProps = {
  labelKey?: string;
  level: number;
};

export const HistoryChangeSection = ({
  labelKey,
  level,
  children
}: PropsWithChildren<HistoryChangeSectionProps>) => {
  const { t } = useTranslation("activities", { keyPrefix: "show.history.entry.updatedAttributes" });
  const activity = useCurrentActivity();
  const template = useTemplate(activity.template_id);
  const templatePropertyTitle = propertyToTitle(template, snakeCase(labelKey || ""));

  const label =
    t(`labels.${labelKey}` as unknown as TemplateStringsArray, { defaultValue: "" }) ||
    templatePropertyTitle ||
    humanize(labelKey || "");

  return (
    <Stack className={classNames(css.container, { [css.indent]: level > 1 })}>
      {label && (
        <Typography
          className={css.updateAttributeTitle}
          variant={LabelLevelVariants[level - 1] || "labelBold"}
        >
          {label}
        </Typography>
      )}
      {children}
    </Stack>
  );
};
